import { render, staticRenderFns } from "./delete-button.vue?vue&type=template&id=9976c582&scoped=true"
import script from "./delete-button.vue?vue&type=script&lang=js"
export * from "./delete-button.vue?vue&type=script&lang=js"
import style0 from "./delete-button.vue?vue&type=style&index=0&id=9976c582&prod&lang=scss&scoped=true"
import style1 from "./delete-button.vue?vue&type=style&index=1&id=9976c582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9976c582",
  null
  
)

export default component.exports